// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"Modal_modalDialog__PUtnd","modalContent":"Modal_modalContent__Iw7YO"};